<template>
    <div id="start_today_card" class="col-sm-hidden">
        <div class="contact-form-box shadow-box">
            <h4 class="mb-4">Comienza tu solicitud hoy mismo.</h4>
            <div class="axil-contact-form">
                <div class="form-group">
                    <button @click.stop="goToApplicantRegister()"
                        class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button bold" name="submit-btn">
                        Comenzar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StartTodayCard",
    props: ["id", "urlPath", "nameHolder", "emailHolder", "originLanding"],
    data() {
        return {
        
        }
    },
    methods: {
       
    }
}

</script>

<style scoped>
/* .form-floating {
    position: relative;
    top: 6rem;
} */

.start-card {
    position: fixed !important;
    position: absolute;
    bottom: 15rem;
    margin-right: 24rem;
    /* margin-left: -2rem;
    margin-right: 10rem; */
    z-index: 99;
    opacity: 0;
    -webkit-transform: scale(0.3);
    -ms-transform: scale(0.3);
    transform: scale(0.3);
    z-index: 9;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
}

.start-card.show {
    /* bottom: 40px;
        right: 40px; */
    opacity: 1;
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
}

@media only screen and (max-width: 575px) {
    /* .form-floating {
        top: 4rem !important;
    } */
}

@media only screen and (max-width: 991px) {
    .banner.banner-style-2 {
        top: 4rem !important;
    }
}
</style>